
import React from "react";
import { Badge } from "@/components/ui/badge";
import { 
  Bug, 
  Sparkles, 
  RefreshCw, 
  Lightbulb, 
  HelpCircle 
} from "lucide-react";

interface TicketTypeBadgeProps {
  type: 'feature_request' | 'error_report' | 'update_request' | 'suggestion' | 'general';
  className?: string;
  showIcon?: boolean;
}

const TicketTypeBadge: React.FC<TicketTypeBadgeProps> = ({ 
  type, 
  className,
  showIcon = true
}) => {
  const getTypeConfig = () => {
    switch (type) {
      case 'feature_request':
        return { 
          label: 'Feature Request', 
          variant: 'default', 
          bg: 'bg-green-100 text-green-700 border-green-200',
          icon: <Sparkles className="h-3.5 w-3.5 mr-1" />
        };
      case 'error_report':
        return { 
          label: 'Error Report', 
          variant: 'destructive', 
          bg: 'bg-red-100 text-red-700 border-red-200',
          icon: <Bug className="h-3.5 w-3.5 mr-1" />
        };
      case 'update_request':
        return { 
          label: 'Update Request', 
          variant: 'secondary', 
          bg: 'bg-blue-100 text-blue-700 border-blue-200',
          icon: <RefreshCw className="h-3.5 w-3.5 mr-1" />
        };
      case 'suggestion':
        return { 
          label: 'Suggestion', 
          variant: 'secondary', 
          bg: 'bg-purple-100 text-purple-700 border-purple-200',
          icon: <Lightbulb className="h-3.5 w-3.5 mr-1" />
        };
      case 'general':
        return { 
          label: 'General', 
          variant: 'outline', 
          bg: 'bg-gray-100 text-gray-700 border-gray-200',
          icon: <HelpCircle className="h-3.5 w-3.5 mr-1" />
        };
      default:
        return { 
          label: 'Unknown', 
          variant: 'outline', 
          bg: 'bg-gray-100 text-gray-700',
          icon: <HelpCircle className="h-3.5 w-3.5 mr-1" />
        };
    }
  };

  const config = getTypeConfig();

  return (
    <Badge 
      variant="outline" 
      className={`border ${config.bg} ${className}`}
    >
      {showIcon && config.icon}
      {config.label}
    </Badge>
  );
};

export default TicketTypeBadge;
